import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.token) setToken(data.token);
        // Wait until the session is fully established in context before navigating
        await refreshUser();
        // Only route brand-new (first-time) Google signups to the password setup screen
        if (data.is_new_user && data.user && data.user.has_password === false) {
          navigate("/sifre-belirle", { replace: true, state: { user: data.user } });
        } else {
          navigate("/", { replace: true, state: { user: data.user } });
        }
      } catch {
        // fall back to a server session check, then land on home either way
        try { const { data } = await api.get("/auth/me"); setUser(data); } catch { setUser(false); }
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, setUser, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center app-bg">
      <div className="text-center">
        <Loader2 className="h-10 w-10 animate-spin text-emerald-500 mx-auto" />
        <p className="mt-4 text-slate-500 font-medium">Giriş yapılıyor...</p>
      </div>
    </div>
  );
}
